import React from 'react';
import { Button, Form, Input, Checkbox, Modal } from 'antd';
import { withTranslation } from "react-i18next"
import { EditOutlined , PhoneOutlined  } from '@ant-design/icons';
import axios from 'axios';
import { setAccessToken } from '../../utils/tokenUtils';
import config from '../../utils/config';
import UserAgreement from './userAgreement';
import PrivacyAgreement from './privacyAgreement';
import { getLang, openErrorMsg, openSuccessMsg } from '../../utils/messageUtils';
import { defaultLanguageApi } from '../../utils/utils';
import './index.css'

const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};
class LoginPhoneForm extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            publicKey:'',
            captchaKey:'',
            captchaImg:'',
            phoneCaptchaKey:'',
            phone:'',
            isLogin: true,
            isModalOpen: false,
            isSecond: true,
            secondTime: 60,
            isPrivacyModal:false,
        }
    }

    handleCountDown = (seconds) => {
        let second = seconds;
        this.setState({isSecond: false, secondTime:second})
        const countDown = () => {
            if (second > 0) {
            second--;
            this.setState({ secondTime:second})
            }
            if (second === 0) {
            this.setState({isSecond: true})
            second = seconds;
            clearTimeout(second); // 清除计时器
            return;
            }
            setTimeout(countDown, 1000);
        };
        setTimeout(countDown, 1000);
    };

    handleOpenModal = () =>{
        this.setState({ isModalOpen: true })
    }

    handleCloseModal = () =>{
        this.setState({ isModalOpen: false })
    }

    handlePrivacyModal =()=>{
        this.setState({isPrivacyModal:!this.state.isPrivacyModal})
    }


    /**
     * 获取手机验证码
     */
     getPhoneCaptcha = () =>{
        const params = {phone:this.state.phone, lang: getLang()}
        axios
        .get(`${config.API_HOST}/oauth/public/send-phone-captcha`,{params})
        .then((result) => {
            const { data } = result;
            if(data.success){
                openSuccessMsg(this.props.t('tips', { defaultValue: '提示' }), data.message);
                this.handleCountDown(60)
                this.setState({phoneCaptchaKey: data.captchaKey});
            }else{
                openErrorMsg(this.props.t('tips', { defaultValue: '提示' }), data.message);
            }
            
        })
        .catch((err) => {
            console.log(err);
        });
    }



    /**
     * 登录跳转
     */
    jumpUrl = async(loginRes) =>{
        setAccessToken(loginRes?.accessToken);
        const tokenInfo = `#access_token=${loginRes.accessToken}&expires_in=${loginRes.expiresIn}&refresh_token=${loginRes.refreshToken}&scope=${loginRes.scope}`;
        let jumpUrl = '/app/workplace';
        console.log(`${config.DOMAIN_NAME}${jumpUrl}${tokenInfo}`);
        window.location.href = `${config.DOMAIN_NAME}${jumpUrl}${tokenInfo}`;
    }

    /**
     * 验证码登录
     * @param {*} values 
     */
    onFinish = async (values) => {
        console.log('values----', values);
        const data = {
            grant_type:'implicit',
            client_id:'client',
            client_secret:'secret',
            source_type:'web',
            device_id:new Date().getTime(),
            captchaKey: this.state.phoneCaptchaKey,
            phone: values.phone,
            captcha: values.captcha,
            lang: getLang(),

        }
        console.log('params===',data);
        axios
        .post(`${config.API_HOST}/oauth/token/mobile`,data, {
            headers: {
                "Content-type": "application/x-www-form-urlencoded"
            }
          })
        .then(async(result) => {
            const { data } = result;
            if(data.success){
                // const loginRes= result.data;
                console.log('result====',data);
                await defaultLanguageApi(data?.accessToken);
                await this.jumpUrl(data);
            }else{
                openErrorMsg(this.props.t('tips', { defaultValue: '提示' }), data.message);
            }
            
        })
        .catch((err) => {
            const data = err.response.data;
            openErrorMsg(this.props.t('tips', { defaultValue: '提示' }), data.message);
        }); 
    }

    phoneChange = (e) =>{
        this.setState({phone:e.target.value})
        console.log(e.target.value);
    }

    boxChange = (e) =>{
        console.log(e);
        this.setState({isLogin: !e.target.checked})
    }

    toHome = () =>{
        console.log('this==',this.props);
        this.props.history.push('/home');
    }

    passwordFind = () =>{
        this.props.history.push('/passwordFind');
    }

    render() {
        return (
            <div className="login-form-user">
                <Form
                    {...layout}
                    name="basic"
                    ref={this.formRef}
                    size='large'
                    onFinish={this.onFinish.bind(this)}
                >
                    <Form.Item name="phone" rules={[{ required: true, message: this.props.t('phonePlaceholder', { defaultValue: '请输入手机号' }) }]}>
                        <Input prefix={<PhoneOutlined />}  onChange={this.phoneChange.bind(this)}  placeholder={ this.props.t('phonePlaceholder', { defaultValue: '请输入手机号' }) } />
                    </Form.Item>
                    <Form.Item name="captcha" rules={[{ required: true, message: this.props.t('captchaPlaceholder', { defaultValue: '请输入验证码' }) }]} >
                       
                            {/* <Form.Item
                                name="captcha"
                                noStyle
                                rules={[{ required: true, message: '请输入验证码' }]}
                            > */}
                            <Input prefix={<EditOutlined />} placeholder={ this.props.t('captchaPlaceholder', { defaultValue: '请输入验证码' }) } suffix={
                            <Button type='link' disabled={!this.state.isSecond}  onClick={this.getPhoneCaptcha.bind(this)}>
                                {this.state.isSecond
                                ? this.props.t('getcCptcha', { defaultValue: '获取验证码' })
                                : `${this.state.secondTime}S`}</Button>
                            } />
                            {/* </Form.Item> */}
                       
                       
                    </Form.Item>

                    <Form.Item>
                        <Form.Item name="remember" valuePropName="checked" noStyle>
                            <Checkbox onChange={this.boxChange.bind(this)}>{ this.props.t('readCheckbox', { defaultValue: '我已阅读并同意' }) }</Checkbox>
                        </Form.Item>

                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a className="login-form-forgot" onClick={this.handleOpenModal}>
                            { this.props.t('agreement', { defaultValue: '《用户许可协议》' }) }
                        </a>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a style={{marginLeft:10}} className="login-form-forgot" onClick={this.handlePrivacyModal}>
                            { this.props.t('privacyAgreement', { defaultValue: '《隐私协议》' }) }
                        </a>
                        <span onClick={this.passwordFind.bind(this)} style={{float: 'right'}}>{ this.props.t('forgotPassword', { defaultValue: '忘记密码' }) }</span>
                    </Form.Item>
                
                    <div>
                        <Form.Item className="">
                            <Button disabled={this.state.isLogin} type="primary" htmlType="submit" loading={this.state.loading} className="login-form-button">{ this.props.t('login', { defaultValue: '登录' }) }</Button>
                            <span onClick={this.toHome.bind(this)} className='to-home'>{ this.props.t('goHome', { defaultValue: '返回首页' }) }</span>
                        </Form.Item>
                    </div>
                </Form>

                <Modal 
                    className='agreement-modal' 
                    width={800}
                    open={this.state.isModalOpen} 
                    onCancel={this.handleCloseModal}
                    footer={[
                        <Button key="submit" type="primary" onClick={this.handleCloseModal} >
                            { this.props.t('close', { defaultValue: '关闭' }) }
                        </Button>,
                        ]}
                >
                    <UserAgreement />
                </Modal>
                {this.state.isPrivacyModal && (
                    <Modal 
                        className='privacy-agreement-modal' 
                        width={900}
                        open={this.state.isPrivacyModal} 
                        onCancel={this.handlePrivacyModal}
                        footer={[
                        <Button key="submit" type="primary" onClick={this.handlePrivacyModal} >
                        { this.props.t('close', { defaultValue: '关闭' }) }
                        </Button>,
                        ]}
                    >
                        <PrivacyAgreement />
                    </Modal>
                )}
                
            </div>
        )
    }
}

export default LoginPhoneForm = withTranslation()(LoginPhoneForm);